import React, { FC } from "react"
// eslint-disable-next-line import/no-unresolved
import { SwiperSlide } from "swiper/react"
import { Autoplay } from "swiper"
import { Content, SlidingTextWrapper, StyledSwiper } from "./styles"

const SlidingText: FC = ({
    children
}) => {
    return <SlidingTextWrapper>
        <StyledSwiper
            loop
            speed={18000}
            autoplay={{
                delay: 1,
                disableOnInteraction: false
            }}
            mousewheel={false}
            keyboard={false}
            slidesPerView="auto"
            breakpoints={{
                768: {
                    spaceBetween: 55
                }
            }}
            spaceBetween={30}
            modules={[Autoplay]}
        >
            {Array.from({ length: 5 }).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <SwiperSlide key={index}>
                    <Content>
                        {children}
                    </Content>
                </SwiperSlide>
            ))}
        </StyledSwiper>
    </SlidingTextWrapper>
}

export default SlidingText
